module.exports = __webpack_public_path__ + "img/content-1.2b8fc16d.png";